class SeasonalTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('.tab-button');
    this.tabs = this.querySelectorAll('.seasonal-tab');
    this.nextButton = this.querySelector('.next-btn');
    this.prevButton = this.querySelector('.prev-btn');

    this.activeTabButton = this.getClosestTabByDate();

    this.activeTabButton.classList.add('active');
    this.querySelector(`[data-id="${this.activeTabButton.id}"]`).classList.add('active');

    this.buttons.forEach(button => button.addEventListener('click', this.onTabClick.bind(this)));

    this.nextButton.addEventListener('click', this.onNextClick.bind(this));
    this.prevButton.addEventListener('click', this.onPrevClick.bind(this));

    this.querySelectorAll('.product-card-wrapper')
      .forEach((productCard) => {
        productCard.addEventListener('click', this.onShowProductInfo.bind(this))
      })
  }

  onTabClick (e) {
    this.buttons.forEach(button => button.classList.remove('active'));
    this.tabs.forEach(tab => tab.classList.remove('active'));

    this.querySelectorAll('.seasonal-cheese__product-info')
      .forEach((el) => {
        el.classList.remove('active');
      })

    this.activeTabButton = e.target;
    e.target.classList.add('active');
    this.querySelector(`.seasonal-tab[data-id="${e.target.id}"]`).classList.add('active');
  }

  updateTab (newTab) {
    if (!newTab || !newTab.classList.contains('tab-button')) return;

    this.querySelectorAll('.seasonal-cheese__product-info')
      .forEach((el) => {
        el.classList.remove('active');
      })

    this.buttons.forEach(button => button.classList.remove('active'));
    this.tabs.forEach(tab => tab.classList.remove('active'));

    this.activeTabButton = newTab;
    newTab.classList.add('active');
    this.querySelector(`.seasonal-tab[data-id="${newTab.id}"]`).classList.add('active');
  }

  onNextClick () {
    this.updateTab(this.activeTabButton.nextElementSibling);
  }

  onPrevClick () {
    this.updateTab(this.activeTabButton.previousElementSibling);
  }

  getClosestTabByDate () {
    const parseDate = date => new Date(date.replace(/(\d{2})\/(\d{2})\/(\d{4})/g, '$2/$1/$3'));
    const diff = (date, now) => Math.abs(parseDate(date) - now);
    const comparator = now => (tab1, tab2) => {
      return diff(tab1.dataset.date, now) - diff(tab2.dataset.date, now);
    }

    const thisMonth = new Date(new Date().setDate(1));

    const [closest] = Array.from(this.buttons).sort(comparator(thisMonth));

    return closest;
  }

  onShowProductInfo (e) {
    e.preventDefault();

    const product = e.target.closest('.product-card-wrapper').dataset.product;

    this.querySelectorAll('.seasonal-cheese__product-info')
      .forEach((el) => {
        el.classList.remove('active');
      })

    const el = this.querySelector('.seasonal-tab.active .seasonal-cheese__product-info#sc-' + product)
    el.classList.add('active');
    el.scrollIntoView({
      block: 'nearest'
    });
  }
}

customElements.define('seasonal-tabs', SeasonalTabs);